import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GisSearchCoordFilterModel } from '../models/localization/gis-search-coord.filter.model';
import { GisSearchCoordResponseModel } from '../models/localization/gis-search-coord.response.model';
import { JsonResult } from '../core/json-result.model';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../core/services/environment.service';

@Injectable({
    providedIn: 'root'
})
export class GisService {
    [x: string]: any;
    controller: string = "Localization";
    constructor(private httpClient: HttpClient,
        private environmentService: EnvironmentService) {

    }

    /**
     * Buscar coordenadas 
     * @param params solicitar puntos de GIS
     */
    SearchPrediosCoordenadas(latitud: number, longitude: number,tipoServicio:string,direccion:string,archivoBase64:string): Observable<JsonResult<GisSearchCoordResponseModel>> {

        let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/SearchGasNetworkPredios`;

        const params = {
            req: {
                x_in: longitude.toString(),
                y_in: latitud.toString(),
                tipoServicio,
                direccion,
                archivoBase64
            }
        } as GisSearchCoordFilterModel;
        return this.httpClient.post<JsonResult<GisSearchCoordResponseModel>>(url, params,
            { responseType: 'json' }
        );
    }
}  